
/**
 * used to convert a hexa number in '#000fff' format, 
 * to an integer.
 * @param num 
 */
export function hexToInt(num: string): number {
    return parseInt(num.replace(/^#/, '0x'), 16);
}

/**
 * used to convert an integer number,
 * to a hexa number.
 * @param num
 */
export function intToHex(num: number): string {
    return "#" + ('000000' + ((num) >>> 0).toString(16)).slice(-6);
}